<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="推荐机构" name="first">
                <swb-servc-work-voucher-ds-assign-shop-select ref="swb_servc_work_ds_assign_shop" :merchantId="merchantId" :comId="comId" :comLevel="comLevel" :voucherId="voucherId" :buyerShopLat="buyerShopLat" :buyerShopLng="buyerShopLng" :servcId="servcId" :servcType="servcType" :buyerShopId="buyerShopId" :devcCatId="devcCatId" :servcCatId="servcCatId"></swb-servc-work-voucher-ds-assign-shop-select>
            </el-tab-pane>
            <el-tab-pane label="全部机构" name="all">
                <swb-org-tree :enableSearch="true" :isRadio="true" :accordion="true" :merchantId="merchantId" :isCom="true" ref="swb_retail_org_tree"></swb-org-tree>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import SwbServicerOrgTree from '../orgStruct/ServicerOrgTree';
    Vue.regist(SwbServicerOrgTree);

    import SwbServcWorkVoucherDsAssignShopSelect from '../easyReport/ServcWorkVoucherDsAssignShopSelect';
    Vue.regist(SwbServcWorkVoucherDsAssignShopSelect);

    export default {
        name: 'swb-servc-work-voucher-dispatch-shop-select',
        props: ['merchantId', 'comId', 'comLevel', 'voucherId', 'assignShop', 'buyerShopLat', 'buyerShopLng', 'servcId', 'servcType', 'buyerShopId', 'devcCatId', 'servcCatId'],
        data: function () {
            return {
                activeName: 'first'
            }
        },
        created: function () {

        },
        methods: {
            handleClick(){

            },
            getDlgResult(){
                let activeName = this.activeName;
                if(activeName == 'all') {
                    let result = this.$refs.swb_retail_org_tree.getDlgResult() || {};
                    if(result.type == "info") {
                        let retailerCom = result.data;
                        return retailerCom;
                    } else {
                        return null;
                    }
                } else {
                    let servicerCom = this.$refs.swb_servc_work_ds_assign_shop.getDlgResult() || {};
                    servicerCom.shopFlag = true;
                    return servicerCom;
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherDispatchShopSelect.vue